import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

/**
 * Services
 */
import { AuthenticationService } from '@services/laravel/authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * @description Permission to navigate to any route IF there is an user loggedin ELSE force navigation to login route
 *    @extends _auth.setUser() - AuthenticationService method
 *        @returns user object with its id IF there is an user loggedin ELSE false
 *    @extends _auth.router - Router
 *        @returns navigate to login IF there is no user loggedin ELSE user will be allowed to navigate to any route under auth.guard
 */

@Injectable()
export class AuthGuard  {
  constructor(
    private _auth: AuthenticationService,
    private _router: Router,
    public _snackbar: MatSnackBar
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot, state:
    RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean
  {
    return this._auth.setUser()
      .then((res: any) => {
        if (res?.id) {
          return true;
        }

        this._auth.logout();
        this._router.navigate(['/']);
        return false;
      })
      .catch(() => {
        this._auth.logout();
        this._router.navigate(['/']);
        return false;
      });
  }
}
